import { render, staticRenderFns } from "./StarterPackDrawerBattle.vue?vue&type=template&id=610f7cfc&scoped=true"
import script from "./StarterPackDrawerBattle.vue?vue&type=script&lang=js"
export * from "./StarterPackDrawerBattle.vue?vue&type=script&lang=js"
import style0 from "./StarterPackDrawerBattle.vue?vue&type=style&index=0&id=610f7cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f7cfc",
  null
  
)

export default component.exports